<template>
    <div>
      <div class="col-lg-2">
        <base-button
          style="font-size: 18px"
          @click="getBack()"
          class="btn-link btn-primary"
        >
          &lt; Back
        </base-button>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-md-12">
          <simple-wizard ref="tabs" :indextghrunning="huhuhaha" :totalstep="hoi">
            <template slot="header">
              <h2 class="card-title"></h2>
              <h3 class="description"></h3>
            </template>
  
            <wizard-tab
              :activeTabIndex="activeTabIndex"
              :before-change="() => validateStep('step1')"
            >
              <template slot="label">
                1
  
                <p style="color: #A5A5A5">WCO</p>
              </template>
              <first-step
                @my-event="myFunction"
                ref="step1"
                @on-validated="onStepValidated"
              ></first-step>
            </wizard-tab>
<!--   
            <wizard-tab
              :activeTabIndex="activeTabIndex"
              :before-change="() => validateStep('step2')"
            >
              <template slot="label">
                2
                <p style="color: #A5A5A5; width: 200px">Quotation</p>
              </template>
              <second-step
                @my-event="myFunction"
                ref="step2"
                @on-validated="onStepValidated"
              ></second-step>
            </wizard-tab>
  
            <wizard-tab
              :before-change="() => validateStep('step3')"
              :activeTabIndex="activeTabIndex"
            >
              <template slot="label">
                3
                <p style="color: #A5A5A5; width: 200px">Collection Schedule</p>
              </template>
              <third-step
                @my-event="myFunction"
                ref="step3"
                @on-validated="onStepValidated"
              ></third-step>
            </wizard-tab>
  
            <wizard-tab
              :before-change="() => validateStep('step4')"
              :activeTabIndex="activeTabIndex"
            >
              <template slot="label">
                4
                <p style="color: #A5A5A5; width: 200px">Operation Activities</p>
              </template>
              <fourth-step
                @my-event="myFunction"
                ref="step4"
                @on-validated="onStepValidated"
              ></fourth-step>
            </wizard-tab>
  
            <wizard-tab
              :before-change="() => validateStep('step5')"
              :activeTabIndex="activeTabIndex"
            >
              <template slot="label">
                5
                <p style="color: #A5A5A5; width: 200px">Gate Pass</p>
              </template>
              <fifth-step
                @my-event="myFunction"
                ref="step5"
                @on-validated="onStepValidated"
              ></fifth-step>
            </wizard-tab>
  
            <wizard-tab
              :before-change="() => validateStep('step6')"
              :activeTabIndex="activeTabIndex"
            >
              <template slot="label">
                6
                <p style="color: #A5A5A5; width: 200px">WDO</p>
              </template>
              <sixth-step
                @my-event="myFunction"
                ref="step6"
                @on-validated="onStepValidated"
              ></sixth-step>
            </wizard-tab>
  
            <wizard-tab
              :before-change="() => validateStep('step7')"
              :activeTabIndex="activeTabIndex"
            >
              <template slot="label">
                7
                <p style="color: #A5A5A5; width: 200px">Invoice</p>
              </template>
              <seven-step
                @my-event="myFunction"
                ref="step7"
                @on-validated="onStepValidated"
              ></seven-step>
            </wizard-tab> -->
  
            <!-- <wizard-tab
              :before-change="() => validateStep('step8')"
              :activeTabIndex="activeTabIndex"
            >
              <template slot="label">
                8
                <p style="color: #A5A5A5; width: 200px"></p>
              </template>
              <eight-step
                @my-event="myFunction"
                ref="step8"
                @on-validated="onStepValidated"
              ></eight-step>
            </wizard-tab>-->
          </simple-wizard> 
        </div>
      </div>
    </div>
  </template>
  <script>
  import FirstStep from "../../Admin/Incoming/OtherJobPage/WCO.vue";
//   import SecondStep from "../../Admin/Incoming/ScrapJobPage/Quotation.vue";
//   import ThirdStep from "../../Admin/Incoming/ScrapJobPage/CollectionSchedule.vue";
//   import FourthStep from "../../Admin/Incoming/ScrapJobPage/OperationActivities.vue";
//   import FifthStep from "../../Admin/Incoming/ScrapJobPage/GatePass.vue";
//   import SixthStep from  "../../Admin/Incoming/ScrapJobPage/WDO.vue";
//   import SevenStep from "../../Admin/Incoming/ScrapJobPage/Invoice.vue";
  // import EightStep from 
  import swal from "sweetalert2";
  import { SimpleWizard, WizardTab } from "src/components";
  
  export default {
    data() {
      return {
        wizardModel: {},
        activeTabIndex: 0,
        jobstatus: "",
        landvesselflag: "VESSEL",
        huhuhaha:0,
        hoi: 0,
      };
    },
    components: {
      FirstStep,
    //   SecondStep,
    //   ThirdStep,
    //   FourthStep,
    //   FifthStep,
    //   SixthStep,
    //   SevenStep,
      // EightStep,
      SimpleWizard,
      WizardTab,
    },
    created() {
      this.getDetail(this.$route.params.jobnum.split("_")[0]);
    },
    methods: {
      getDetail(refNo) {
        this.$http.get(":10001/api/v1/incoming/others/" + refNo).then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            // this.landvesselflag = response.company.company_type.toUpperCase();
            this.huhuhaha = response.dashboard_step;
            this.hoi = 1;
          }
        });
      },
      myFunction(e) {
          console.log(e)
        let index = parseInt(e.step);
  
        if (e.direction == "depan") {
          // bila step 1, dia kan move ke step 2
          if (e.step == "1") {
            // active = content of child
            // checked = bullet tab
            // display quotation page
  
            console.log(this.$refs.step1);
            // this.$refs.tabs.tabs[index].active = true;
            // this.$refs.tabs.tabs[index].checked = true;
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 1].active = true;
              this.$refs.tabs.tabs[index - 1].checked = true;
              this.huhuhaha = parseInt(e.step);
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
  
            this.$emit("update:startIndex", index);
          }
  
          if (e.step == "2") {
            // display ptw page
            this.$refs.tabs.tabs[index].active = true;
            this.$refs.tabs.tabs[index].checked = true;
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = true;
              this.$refs.tabs.tabs[index - 2].active = false;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.huhuhaha = parseInt(e.step);
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
            // let newValue = index + 1;
            this.$emit("update:startIndex", index);
          }
  
          if (e.step == "3") {
            // display collection schedule page
            this.$refs.tabs.tabs[index].active = true;
            this.$refs.tabs.tabs[index].checked = true;
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = true;
              this.$refs.tabs.tabs[index - 2].active = false;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.huhuhaha = parseInt(e.step);
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
            // let newValue = index + 1;
            this.$emit("update:startIndex", index);
          }
  
          if (e.step == "4") {
            // display collection schedule page
            this.$refs.tabs.tabs[index].active = true;
            this.$refs.tabs.tabs[index].checked = true;
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = true;
              this.$refs.tabs.tabs[index - 2].active = false;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.$refs.tabs.tabs[index - 4].active = false;
              this.$refs.tabs.tabs[index - 4].checked = true;
              this.huhuhaha = parseInt(e.step);
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
            // let newValue = index + 1;
            this.$emit("update:startIndex", index);
          }
  
          if (e.step == "5") {
            // display collection schedule page
            this.$refs.tabs.tabs[index].active = true;
            this.$refs.tabs.tabs[index].checked = true;
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = true;
              this.$refs.tabs.tabs[index - 2].active = false;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.$refs.tabs.tabs[index - 4].active = false;
              this.$refs.tabs.tabs[index - 4].checked = true;
              this.$refs.tabs.tabs[index - 5].active = false;
              this.$refs.tabs.tabs[index - 5].checked = true;
              this.huhuhaha = parseInt(e.step);
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
            // let newValue = index + 1;
            this.$emit("update:startIndex", index);
          }
  
          if (e.step == "6") {
            // display collection schedule page
  
            this.$refs.tabs.tabs[index].active = true;
            this.$refs.tabs.tabs[index].checked = true;
            console.log(this.$refs.tabs.tabs[index].active);
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = true;
              this.$refs.tabs.tabs[index - 2].active = false;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.$refs.tabs.tabs[index - 4].active = false;
              this.$refs.tabs.tabs[index - 4].checked = true;
              this.$refs.tabs.tabs[index - 5].active = false;
              this.$refs.tabs.tabs[index - 5].checked = true;
              this.$refs.tabs.tabs[index - 6].active = false;
              this.$refs.tabs.tabs[index - 6].checked = true;
              this.huhuhaha = parseInt(e.step);
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
            // let newValue = index + 1;
            this.$emit("update:startIndex", index);
            console.log(this.$refs.tabs);
          }
  
          if (e.step == "7") {
            // display collection schedule page
  
            this.$refs.tabs.tabs[index].active = true;
            this.$refs.tabs.tabs[index].checked = true;
            console.log(this.$refs.tabs.tabs[index].active);
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = true;
              this.$refs.tabs.tabs[index - 2].active = false;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.$refs.tabs.tabs[index - 4].active = false;
              this.$refs.tabs.tabs[index - 4].checked = true;
              this.$refs.tabs.tabs[index - 5].active = false;
              this.$refs.tabs.tabs[index - 5].checked = true;
              this.$refs.tabs.tabs[index - 6].active = false;
              this.$refs.tabs.tabs[index - 6].checked = true;
              this.$refs.tabs.tabs[index - 7].active = false;
              this.$refs.tabs.tabs[index - 7].checked = true;
              this.huhuhaha = parseInt(e.step);
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
            // let newValue = index + 1;
            this.$emit("update:startIndex", index);
            console.log(this.$refs.tabs);
          }
        }
  
        if (e.direction == "blkg") {
          if (e.step == "1") {
            this.getBack();
          }
  
          if (e.step == "2") {
            // display ANF
            this.$refs.tabs.tabs[index - 2].active = true;
            this.$refs.tabs.tabs[index - 2].checked = false;
            this.$refs.tabs.tabs[index - 1].active = false;
            this.$refs.tabs.tabs[index - 1].checked = false;
            this.$refs.tabs.tabs[index].active = false;
            this.$refs.tabs.tabs[index].checked = false;
            this.huhuhaha = parseInt(e.step) - 2;
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
            let newValue = index + 1;
            this.$emit("update:startIndex", newValue);
          }
  
          if (e.step == "3") {
            // display quotation
  
            this.$refs.tabs.tabs[index - 2].active = true;
            this.$refs.tabs.tabs[index - 2].checked = true;
            this.$refs.tabs.tabs[index - 1].active = false;
            this.$refs.tabs.tabs[index - 1].checked = false;
            this.$refs.tabs.tabs[index].active = false;
            this.$refs.tabs.tabs[index].checked = false;
            this.huhuhaha = parseInt(e.step) - 2;
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
            let newValue = index + 1;
            this.$emit("update:startIndex", newValue);
          }
  
          if (e.step == "4") {
            console.log("belakang 4");
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.$refs.tabs.tabs[index - 2].active = true;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = false;
              this.$refs.tabs.tabs[index].active = false;
              this.$refs.tabs.tabs[index].checked = false;
              console.log(parseInt(e.step) - 2);
              this.huhuhaha = parseInt(e.step) - 2;
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
            let newValue = index + 1;
            this.$emit("update:startIndex", newValue);
          }
  
          if (e.step == "5") {
            console.log("masuk 5");
  
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 4].active = false;
              this.$refs.tabs.tabs[index - 4].checked = true;
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.$refs.tabs.tabs[index - 2].active = true;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = false;
              this.$refs.tabs.tabs[index].active = false;
              this.$refs.tabs.tabs[index].checked = false;
              this.huhuhaha = parseInt(e.step) - 2;
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
  
            this.$emit("update:startIndex", index);
          }
  
          if (e.step == "6") {
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 5].active = false;
              this.$refs.tabs.tabs[index - 5].checked = true;
              this.$refs.tabs.tabs[index - 4].active = false;
              this.$refs.tabs.tabs[index - 4].checked = true;
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.$refs.tabs.tabs[index - 2].active = true;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = false;
              this.$refs.tabs.tabs[index].active = false;
              this.$refs.tabs.tabs[index].checked = false;
              this.huhuhaha = parseInt(e.step) - 2;
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
  
            this.$emit("update:startIndex", index);
          }
  
          if (e.step == "7") {
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 6].active = false;
              this.$refs.tabs.tabs[index - 6].checked = true;
              this.$refs.tabs.tabs[index - 5].active = false;
              this.$refs.tabs.tabs[index - 5].checked = true;
              this.$refs.tabs.tabs[index - 4].active = false;
              this.$refs.tabs.tabs[index - 4].checked = true;
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.$refs.tabs.tabs[index - 2].active = true;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = false;
              this.$refs.tabs.tabs[index].active = false;
              this.$refs.tabs.tabs[index].checked = false;
              this.huhuhaha = parseInt(e.step) - 2;
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
  
            this.$emit("update:startIndex", index);
          }
  
          if (e.step == "8") {
            setTimeout(() => {
              this.$refs.tabs.tabs[index - 7].active = false;
              this.$refs.tabs.tabs[index - 7].checked = true;
              this.$refs.tabs.tabs[index - 6].active = false;
              this.$refs.tabs.tabs[index - 6].checked = true;
              this.$refs.tabs.tabs[index - 5].active = false;
              this.$refs.tabs.tabs[index - 5].checked = true;
              this.$refs.tabs.tabs[index - 4].active = false;
              this.$refs.tabs.tabs[index - 4].checked = true;
              this.$refs.tabs.tabs[index - 3].active = false;
              this.$refs.tabs.tabs[index - 3].checked = true;
              this.$refs.tabs.tabs[index - 2].active = true;
              this.$refs.tabs.tabs[index - 2].checked = true;
              this.$refs.tabs.tabs[index - 1].active = false;
              this.$refs.tabs.tabs[index - 1].checked = false;
              this.$refs.tabs.tabs[index].active = false;
              this.$refs.tabs.tabs[index].checked = false;
              this.huhuhaha = parseInt(e.step) - 2;
            }, 100);
  
            this.$emit(
              "tab-change",
              this.$refs.tabs.tabs[index - 1],
              this.$refs.tabs.tabs[index]
            );
  
            this.$emit("update:startIndex", index);
          }
        }
      },
      getBack() {
        this.$router.push("/Incoming");
      },
      validateStep(ref) {
        return this.$refs[ref].validate();
      },
      validate(tab) {
        let tabToValidate = tab || this.activeTab;
  
        let beforeChange = tabToValidate.beforeChange;
        if (beforeChange) {
          return Promise.resolve(beforeChange())
            .then((res) => {
              this.activeTab.hasError = res ? false : true;
              return res;
            })
            .catch(() => {
              this.activeTab.hasError = true;
            });
        } else {
          return Promise.resolve(true);
        }
      },
      onStepValidated(validated, model) {
        this.wizardModel = { ...this.wizardModel, ...model };
      },
      wizardComplete() {
        swal("Good job!", "You clicked the finish button!", "success");
      },
    },
  };
  </script>
  